import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import { createUseStyles } from "react-jss";

// core components
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import LogoutButton from "../LogoutButton/LogoutButton";

import styles from "../../assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";

const useStyles = createUseStyles(styles);

function HeaderLinks(props) {
    const classes = useStyles();
    const { rtlActive } = props;

    const wrapper = classNames({
        [classes.wrapperRTL]: rtlActive,
    });

    return (
        <div className={wrapper} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ThemeToggle size="sm" />
            <LanguageSwitcher size="sm" />
            <LogoutButton size="sm" />
        </div>
    );
}

HeaderLinks.propTypes = {
    rtlActive: PropTypes.bool,
};

export default HeaderLinks;
